<template>
  <div class="Login">
    <div class="Login-fied">
        <div class="login-box">
              <h1>TAL射箭连锁管理系统</h1>
              <div class="input">
                <Input v-model="Name" placeholder="用户名" />
              </div>
              <div class="password">
                 <Input type="password" v-model="password" placeholder="密码" @keyup.enter.native="saveQueryConditions"/>
              </div>
               <!-- <button class="but" @click.stop="loginclick">登录</button> -->
                <div class="code-btn-inner" id="cbox">
                  <span>登录</span></div>
               <div v-show="slideShow" style="position:absolute;top:200px;left:50%;transform:translateX(-50%);" id='slidebox'>
                <!-- <slide-verify :sliderLeft="num"
                      :sliderText='text'
                      :r="10"
                      :w="310"
                      :h="155"
                      @success="onSuccess"
                      @fail="onFail"
                      @refresh="onRefresh"
                ></slide-verify> -->
              </div>
        </div>

    </div>


    <div class="float" v-show="float">
        <div class="float-box">
          <p style="text-align: right;width: 90%;padding: 20px 0; margin: 0 auto;"><img src="@/assets/img/homeX.png" alt="" @click="imgClick"></p>
          <h1>扫描下方微信小程序二维码
进行后续操作</h1>
<div style="margin: 22px auto auto auto;width: 317px;"><img src="@/assets/img/homeR.png" alt=""></div>
        </div>
    </div>

  </div>
</template>

<script>
import slideVerify from'@/components/vue-monoplasty-slide-verify/lib/slide-verify'
import {data} from '@/utils/data.js'
import {Login,getmenu} from '@/api/axios'
export default {
  name: 'Login',
  props: {
    msg: String
  },
  components:{
    slideVerify
  },
  data () {
    return{
      float:false,
      Name:'',
      password:'',
      text: '向右滑',
      slideShow:false,
      num:0,
    }
  },
  mounted(){
    let _this = this;
      document.addEventListener('click', function (e) {
　　　　// 下面这句代码是获取 点击的区域是否包含你的菜单，如果包含，说明点击的是菜单以外，不包含则为菜单以内
      let flag = e.target.contains(document.getElementById('slidebox'))
      if(!flag) return
      _this.slideShow = false

      })
    sessionStorage.clear();
    this.$router.options.routes[1].children=[]
    this.touchimg();
     $('.yp-riddler-mark img').remove()
          //this.$nextTick(()=>{
          //  $('.yp-riddler-button_text').html('登录');
          //   $('.yp-riddler-btn_a').remove();
          //   $('.yp-riddler-btn_b').remove();
          //   $('.yp-riddler-button_logo').remove();
          //   $('.code-btn-inners').hide()
          // })
  },
  methods:{
    saveQueryConditions(){
      document.getElementById('cbox').click();
    },
      touchimg(){
          var _thiss = this;
        //  window.onload = function () {
            // 初始化
            var yp = new YpRiddler({
                expired: 10,
                mode: 'dialog',
                noButton:true,
                winWidth: 300,
                lang: 'zh-cn', // 界面语言, 目前支持: 中文简体 zh-cn, 英语 en
                // langPack: LANG_OTHER, // 你可以通过该参数自定义语言包, 其优先级高于lang
                container: document.getElementById('cbox'),
                appId: '21044299c8c649588b1548aa8c2e46b9',
                version: 'v1',
                onError: function (param) {
                    if (param.code == 429) {
                         _thiss.$Message.info('请求过于频繁，请稍后再试！');
                        return
                    }
                    // 异常回调
                    console.error('验证服务异常')
                },
                onSuccess: function (validInfo, close) {
                    _thiss.login();
                },
                onFail: function (code, msg, retry) {
                    retry()
                },
                beforeStart: function (next) {
                    if (_thiss.Name=='') {
                        _thiss.$Message.error("请输入用户名");
                        return;
                    }
                    next()
                },
                onExit: function () {
                    // 退出验证 （仅限dialog模式有效）
                }

            })



        },
    imgClick(){
        this.float = false;
    },
    onSuccess(){
      this.slideShow=false;
      this.login();
    },
    onFail(){

    },
    onRefresh(){
    },
    loginclick(){
      this.slideShow=true;
    },
    login(){
      Login(this.Name,this.password).then(res => {
        if(res.data.success==true){

          sessionStorage.user=true;
          sessionStorage.userId=res.data.result.userInfo.userId;
          sessionStorage.token=res.data.result.userInfo.token;
          sessionStorage.realName=res.data.result.userInfo.realname;
          if(res.data.result.userInfo.loginStore){
            sessionStorage.storeId=res.data.result.userInfo.loginStore.storeId;

          }
          if(res.data.result.userInfo.loginRole){
            sessionStorage.roleCode=res.data.result.userInfo.loginRole.roleCode;


          }

          if(res.data.result.userInfo.loginCompany){
            sessionStorage.companyId=res.data.result.userInfo.loginCompany.companyId;

          }else{
            $('.yp-riddler-win-masker').hide()
              this.float = true;
          }
          // sessionStorage.menu=JSON.stringify(data.result.menu);
          // let menu=data.result.menu;
          getmenu().then(res=>{
            if(res.data.success==true){
                sessionStorage.menu=JSON.stringify(res.data.result.menu);
                let menu=res.data.result.menu;
                menu.forEach(item=>{
                    // 使用路由懒加载拼接路由路径获取组件
                  if(item.children && item.hasChildrenShow==1){
                      item.children.forEach(child=>{
                          let route = {}

                          route.component=()=>import(`@/components/${child.component}.vue`)
                          route.path='/' + child.path;
                          route.meta={
                              title:child.meta.title
                          }
                          if(child.redirect){
                              route.redirect=child.redirect
                          }
                          if(child.children && child.children.length>0){//子组件下有子组件  不被显示在菜单中，只在页面中切换
                              route.children=child.children;
                              child.children.forEach(childer=>{
                                  childer.path='/'+childer.path;
                                  let childcomponents=`components/${childer.component}.vue`;
                                  childer.component=()=>import(`@/${childcomponents}`)
                              })
                          }
                          route.routershow=child.hidden;
                          this.$router.options.routes[1].children.push(route)
                      })
                    }else if(!item.children && item.hasChildrenShow!=1){

                      let route = {}
                      route.path = '/' + item.path;
                      route.redirect=item.redirect;
                      route.meta={
                          title:item.meta.title
                      }
                      route.component = () => import(`@/components/${item.component}.vue`)
                      this.$router.options.routes[1].children.push(route)
                    }else if(item.children && item.hasChildrenShow!=1){

                      let route = {}
                      route.path = '/' + item.path;
                      route.redirect=item.redirect;
                      route.meta={
                          title:item.meta.title
                      }
                      route.children=item.children;
                      route.component = () => import(`@/components/${item.component}.vue`)
                      item.children.forEach(child=>{
                        child.path='/'+child.path;
                        child.meta={
                            title:child.meta.title
                        }
                        let childcomponents=`components/${child.component}.vue`;
                        child.component=()=>import(`@/${childcomponents}`)
                      })

                      this.$router.options.routes[1].children.push(route)
                    }
                })
                this.$router.addRoutes(this.$router.options.routes)
                this.$router.replace({path:this.$router.options.routes[1].children[0].path});
            }
          })


        }else{
          this.slideShow=false;
          this.num=0;
          this.$Message.error(res.data.message);
          $('.yp-riddler-win-masker').hide()
          return;
        }
      })

    }
  }
}
</script>


<style scoped>
.Login{
  width:100%;
  height:100%;
  background:url(../assets/img/login-bj.jpg)
}

.Login-fied{
  position: fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  display: -webkit-flex;
}

.login-box{
  margin:0 auto;
  align-self:center;
  width: 596px;
	height: 566px;
	background-color: #ffffff;
	box-shadow: 0px 0px 27px 0px
		rgba(119, 119, 119, 0.11);
  border-radius: 4px;
  position: relative;
}

.login-box h1{
  font-size: 32px;
	font-weight: bold;
	line-height: 20px;
	color: #3569fd;
  text-align:center;
  margin-top:95px;
}
.input{
  width: 446px;
  margin:63px auto auto auto;
}

.password{
   width: 446px;
   margin:29px auto auto auto;
}

.but{
  width: 446px;
  height: 54px;
  line-height:54px;
  text-align:center;
	background-color: #3569fd;
  border-radius: 4px;
  font-size: 18px;
	font-weight: bold;
  color: #ffffff;
  border:0;
  margin:78px auto auto auto;
  display: block;
}

.float{
  width:100%;
  height:100%;
  position: fixed;
  left:0;
  top:0;
  background:rgba(0, 0, 0, 0.5);
   display: -webkit-flex;
}

.float-box{
  margin:0 auto;
  align-self:center;
  width: 596px;
	height: 566px;
	background-color: #ffffff;
	box-shadow: 0px 0px 27px 0px
		rgba(119, 119, 119, 0.11);
  border-radius: 4px;
  position: relative;
}
.float-box h1{
  font-size:32px;
  font-weight:bold;
  color:rgba(16,29,55,1);
  line-height:55px;
  width:383px;
  margin:0 auto;
  text-align:center
}

#cbox{
    width: 446px!important;
    height: 54px!important;
    line-height: 54px!important;
    text-align: center!important;
    background-color: #3569fd!important;
    border-radius: 4px!important;
    font-size: 18px!important;
    font-weight: bold!important;
    color: #ffffff!important;
    border: 0!important;
    margin: 78px auto auto auto!important;
    display: block!important;
}

</style>
